import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settlements/")({
  beforeLoad: () => {
    throw redirect({ to: "/expenses" });
  },
});
